/**
 * Compatibility shims for external scripts (e.g., GTM tags) that expect
 * certain DOM elements to exist.
 *
 * This file handles compatibility with legacy external scripts that may
 * try to access DOM elements that don't exist in our React SPA.
 */

/**
 * Creates a hidden input element with id="pageTitle" if it doesn't exist.
 * Some external scripts (e.g., custom GTM tags) may try to access
 * document.getElementById('pageTitle').value, which would throw an error
 * if the element doesn't exist.
 *
 * The element's value is kept in sync with the document title.
 */
export function setupPageTitleElement(): () => void {
  // Create the element if it doesn't exist
  let pageTitleInput = document.getElementById(
    "pageTitle",
  ) as HTMLInputElement | null;
  if (!pageTitleInput) {
    pageTitleInput = document.createElement("input");
    pageTitleInput.type = "hidden";
    pageTitleInput.id = "pageTitle";
    document.body.appendChild(pageTitleInput);
  }

  // Set initial value
  pageTitleInput.value = document.title || "";

  // Watch for title changes and update the input value
  const titleObserver = new MutationObserver(() => {
    if (pageTitleInput) {
      pageTitleInput.value = document.title || "";
    }
  });

  const titleElement = document.querySelector("title");
  if (titleElement) {
    titleObserver.observe(titleElement, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  // Return cleanup function
  return () => {
    titleObserver.disconnect();
  };
}
